/* eslint-disable no-param-reassign */
import getLocaleMixins from '../../utils/getLocaleMixins';
import search from './search.vue';

const name = 'collectList';

export default {
    name,
    mixins: [getLocaleMixins(name)],
    data() {
        const collectApi = this.$im().dataModel.Collect;
        return {
            showAll: true,
            collectList: [],
            typeList: collectApi.typeList,
        };
    },
    computed: {
        showText() {
            return this.typeList.indexOf('RC:TxtMsg') > -1;
        },
        showVoice() {
            return this.typeList.indexOf('RC:VcMsg') > -1;
        },
        showPosition() {
            return this.typeList.indexOf('RC:LBSMsg') > -1;
        },
        showFile() {
            return this.typeList.indexOf('RC:FileMsg') > -1 || this.typeList.indexOf('LRC:fileMsg') > -1;
        },
        showVideo() {
            return this.typeList.indexOf('RC:ImgMsg') > -1
                || this.typeList.indexOf('RC:SightMsg') > -1
                || this.typeList.indexOf('RC:GIFMsg') > -1;
        },
        showLink() {
            return this.typeList.indexOf('RC:ImgTextMsg') > -1;
        },
    },
    watch: {
        $route(newVal, oldVal) {
            if ((newVal.name === 'collect-all' || newVal.name === 'collect') && newVal.name !== oldVal.name) {
                getList(this);
            }
        },
    },
    components: {
        search,
    },
    mounted() {
        const context = this;
        const im = this.$im();
        const dataModel = im.dataModel;
        const typeList = this.typeList;
        if (!typeList || typeList.length === 0) {
            getList(context);
        }
        im.$on('typelistchange', (item) => {
            context.typeList = item;
            dataModel.Collect.typeList = item;
        });
        im.$on('collectList', () => {
            getList(context);
        });
    },
    beforeDestroy() {
        const im = this.$im();
        im.$off('collectList');
        im.$off('typelistchange');
        im.$off('collectlength');
    },
};

function getList(context) {
    const im = context.$im();
    const common = context.RongIM.common;
    const dataModel = im.dataModel;
    const collectApi = dataModel.Collect;
    const params = {
        version: -1,
        scope: 'message',
    };
    collectApi.getList(params, (errorcode, list) => {
        if (errorcode) {
            common.toastError(errorcode);
            context.Busy = false;
            return;
        }
        context.collectList = list;
        const arr = list.map(item => item.objectName);
        context.typeList = arr.filter((x, index, self) => self.indexOf(x) === index);

        context.showAll = true;
        if (arr.length === 0) {
            return;
        }
        const count = arr.reduce((allElements, ele) => {
            if (ele in allElements) {
                allElements[ele] += 1;
            } else {
                allElements[ele] = 1;
            }
            return allElements;
        }, {});
        im.$on('collectlength', (fn) => {
            fn(count, list);
        });
        dataModel.Collect.typeList = context.typeList;
    });
}
